import React, { useState, useEffect } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { Icon } from "@iconify/react";
import { Modal } from "react-bootstrap";

export default function DocumentViewer(props) {
	const [numPages, setNumPages] = useState(null);
	const [pageNumber, setPageNumber] = useState(1);

	useEffect(() => {
		setPageNumber(1);
	}, [props.filePath]);

	const onDocumentLoadSuccess = (data) => {
		setNumPages(data.numPages);
	};

	const nextPage = (value) => {
		if (value <= numPages && value > 0) {
			setPageNumber(value);
		}
	};

	return (
		<Modal
			className="modal fade "
			dialogClassName="modal-90w"
			size="xl"
			backdrop="static"
			show={props.open}
			onHide={props.onHideModal}
		>
			<div>
				{/* {loadingFile && <Loader />} */}
				<div>
					<div className="d-flex justify-content-end me-4 mt-2">
						<Icon
							icon="carbon:close-outline"
							onClick={props.handleClose}
							style={{ fontSize: "26px", cursor: "pointer" }}
						/>
					</div>

					<>
						<Document
							file={props.filePath}
							onLoadSuccess={onDocumentLoadSuccess}
							options={{ workerSrc: "pdf.worker.js" }}
							loading={
								<div
									class="d-flex justify-content-center"
									style={{ marginTop: "50px", marginBottom: "50px" }}
								>
									<div class="spinner-border" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>
								</div>
							}
						>
							<Page pageNumber={pageNumber} height={650} width={1000} />
						</Document>
						<p>
							Page {pageNumber} of {numPages}
						</p>
						<div style={{ display: "flex", justifyContent: "center" }}>
							<p
								onClick={() => nextPage(pageNumber - 1)}
								style={{
									fontWeight: "bold",
									fontSize: "16px",
									marginRight: "20px",
									cursor: "pointer",
								}}
							>
								{"<"}
							</p>
							<p
								onClick={() => nextPage(pageNumber + 1)}
								style={{
									fontWeight: "bold",
									fontSize: "16px",
									marginLeft: "20px",
									cursor: "pointer",
								}}
							>
								{">"}
							</p>
						</div>
					</>
				</div>
			</div>
		</Modal>
	);
}
